import api from "../services/api";

export const addNewOnboardingScreen = (data) => {
    return api.post('admin/onboarding/add', data);
}

export const updateOnboardingScreen = (data) => {
    return api.put('admin/onboarding/update', data);
}

export const updateStatusOnboardingScreen = (data) => {
    return api.put('admin/onboarding/update_status', data);
}

export const listOnboardingScreens = (queryParams) => {
    return api.get(`admin/onboarding/list${queryParams}`);
};

export const deleteOnboardingScreen = ({ _id }) => {
    return api.delete('admin/onboarding/delete', {
        data: { _id }
    });
}